module.exports = __webpack_public_path__ + "img/horizontal_7_1_pp1_5012.7db213ec.png";